function ContactsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M24,10.5v8c0,3.03-2.47,5.5-5.5,5.5H5.5c-3.03,0-5.5-2.47-5.5-5.5V8.5C0,5.47,2.47,3,5.5,3H13.5c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5H5.5c-.96,0-1.79,.54-2.21,1.33l6.94,6.94c.95,.95,2.59,.95,3.54,0,.02-.02,2.75-2.4,2.75-2.4,.62-.54,1.57-.48,2.12,.15,.54,.62,.48,1.57-.15,2.12l-2.64,2.3c-1.03,1.01-2.4,1.57-3.85,1.57s-2.85-.57-3.89-1.61L3,11.28v7.22c0,1.38,1.12,2.5,2.5,2.5h13c1.38,0,2.5-1.12,2.5-2.5V10.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5Zm-3.5-3.5c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5-3.5,1.57-3.5,3.5,1.57,3.5,3.5,3.5Z" />
    </svg>
  );
}

export default ContactsIcon;
